import {ISerializable} from "./ISerializable";
import {IEntity} from "./IEntity";

export abstract class Serializables<T extends IEntity> implements ISerializable{

    protected items:Array<T>;

    constructor(items: Array<T> = []) {
        this.items = items;
    }

    public Serialize(): {} {
        let serializedOccasions:Array<{}> = [];
        for(let item of this.items){
            serializedOccasions.push(item.Serialize());
        }

        return {
            Items: serializedOccasions
        }
    }

    public Deserialize(data: {}): void {
        this.items = [];
        for(let serializedItem of data['Items']){
            let item:T = this.CreateEntity();
            item.Deserialize(serializedItem);
            this.items.push(item);
        }
    }

    public Value():Array<T>{
        return this.items;
    }

    protected abstract CreateEntity():T;

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/typescript-plugin/entities/Serializables.ts